import React from 'react';

export const Footer = () => {
  return (
    <footer className="footer">
      <p>Website created and maintained by <span className="creator">D34thSt4lker</span> and <span className="creator">Nith</span>.</p>
      <p>All game related assets are property of ©DISNEY. ©DISNEY/PIXAR. SOFTWARE ©2020 KABAM GAMES, INC., A NETMARBLE COMPANY.</p>
      <p>Mirrorverse-DB is a fan-made website, therefore it is not affiliated with Disney or Kabam.</p>
    </footer>
  );
}